import React, { useEffect, useState } from 'react';
import NavbarProjects from './NavbarProjects';

const ProjectsTab = ({ data }) => {
  const [bullets, setBullets] = useState([]);
  const [technologies, setTechnologies] = useState([]);

  useEffect(() => {
    const points = data.description.bullets.map((el, i) => {
      return (
        <p className='arrow  my-3 px-3' key={`bullet-point-${i}`}>
          {el}
        </p>
      );
    });
    setBullets(points);

    const tech = data.technologies.map((el, index) => (
      <p key={`technologies-${index}`}>
        {el}
        {index !== data.technologies.length - 1 ? ',' : ''}
      </p>
    ));

    setTechnologies(tech);
  }, []);

  return (
    <div className='tab__content-container' key={data._id}>
      <h3 className='highlight source'>{data.title}</h3>
      <small>
        {data.label} | {data.status}
      </small>

      <p>{data.description.shortDescription}</p>
      {data.technologies && (
        <>
          <div>{bullets}</div>
          <div className='d-flex flex-wrap my-3 justify-content-end'>
            <span className='highlight'>&#91;</span>
            {technologies}
            <span className='highlight'>&#93;</span>
          </div>

          <div className='tab__content-container-links'>
            <a href={data.githubLink} rel='noreferrer' target='_blank'>
              <i className='fa-brands fa-github'></i>
            </a>
            <a href={data.projectLink} rel='noreferrer' target='_blank'>
              <i className='fa-solid fa-square-arrow-up-right'></i>
            </a>
          </div>
        </>
      )}
    </div>
  );
};

const RoleTab = ({ data }) => {
  const [bullets, setBullets] = useState([]);

  useEffect(() => {
    const points = data.description.bullets.map((el, i) => {
      return (
        <p className='arrow  my-3 px-3' key={`bullet-point-${i}`}>
          {el}
        </p>
      );
    });
    setBullets(points);
  }, [data.description.bullets]);

  return (
    <div className='tab__content-container' key={data._id}>
      <h3 className='highlight'>{data.role}</h3>
      <small>{data.year}</small>
      <p>{data.description.shortDescription}</p>
      <div>{bullets}</div>
    </div>
  );
};

const Tab = ({ userDetails }) => {
  const [listContent, setListContent] = useState('');
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    if (userDetails) {
      setActiveTab(userDetails[0].title || userDetails[0].role);
    }
  }, [userDetails]);

  useEffect(() => {
    if (userDetails.length > 0) {
      const contentArr = userDetails.map((data) => {
        return activeTab === data.title ? (
          <ProjectsTab data={data} key={data._id} />
        ) : (
          activeTab === data.role && <RoleTab key={data._id} data={data} />
        );
      });
      setListContent(contentArr);
    }
  }, [userDetails, activeTab]);

  const handleActiveTab = (type) => {
    setActiveTab(type);
  };
  return (
    <div className='tab '>
      {userDetails && (
        <>
          <NavbarProjects
            activeTab={activeTab}
            handleActiveTab={handleActiveTab}
            userDetails={userDetails}
          />

          <div className='tab__content source'>{listContent}</div>
        </>
      )}
    </div>
  );
};

export default Tab;
